module.exports = __webpack_public_path__ + "img/symbol_7.71d9e378.png";